import useAdventureReviews from '../hooks/useAdventureReviews'
import { defineMessage, FormattedMessage, useIntl } from 'react-intl'
import styles from './AdventureReviews.module.scss'
import PropTypes from 'prop-types'
import AdventureReviews from './AdventureReviews'

export default function AdventureReviewsSection({ diveCenterId, rating, reviewsUrl }) {
  const { formatMessage } = useIntl()
  const { pages, count, hasMore, loadMore, loading } = useAdventureReviews(diveCenterId)

  if(!count) {
    return null
  }

  return (
    <div className='wrapper trip-wrapper'>
      <h2 className='do-icon-title'>
        <img
          className={styles.headerIcon}
          src={`${window.staticPath}travel_dist/images/review-stars/star.svg`}
          alt={formatMessage(defineMessage({ defaultMessage: 'Star' }))}
        />
        <FormattedMessage defaultMessage='Reviews' />
      </h2>
      <AdventureReviews
        pages={pages}
        count={count}
        rating={rating}
        reviewsUrl={reviewsUrl}
        hasMore={hasMore}
        loadMore={loadMore}
        loading={loading}
      />
    </div>
  )
}

AdventureReviewsSection.propTypes = {
  diveCenterId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  rating: PropTypes.number.isRequired,
  reviewsUrl: PropTypes.string,
}
